export const sampleData = {
  isLoading: false,
  selectedYear: 2020,
  selectedMonth: 4,
  monthsClosed: [
    { year: 2020, month: 1 },
    { year: 2020, month: 2 },
    { year: 2020, month: 3 },
  ],
  expenses: [
    {
      id: 23441,
      name: 'Czynsz mieszkanie',
      typePayment: 'manual',
      category: { id: 2321, label: 'czynsz', value: 'czynsz' },
      deadline: 10,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [
        { year: 2020, month: 1, status: 'completed', amount: 600 },
        { year: 2020, month: 2, status: 'completed', amount: 600 },
        { year: 2020, month: 3, status: 'completed', amount: 600 },
        { year: 2020, month: 4, status: 'completed', amount: 600 },
      ],
      amountExpected: 600,
      status: 'open',
    },
    {
      id: 55421,
      name: 'Garaz',
      typePayment: 'manual',
      category: { id: 2321, label: 'czynsz', value: 'czynsz' },
      deadline: 17,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [
        { year: 2020, month: 1, status: 'completed', amount: 200 },
        { year: 2020, month: 2, status: 'completed', amount: 200 },
        { year: 2020, month: 3, status: 'completed', amount: 200 },
      ],
      amountExpected: 200,
      status: 'open',
    },
    {
      id: 12367,
      name: 'Rata kredytu za mieszkanie',
      typePayment: 'manual',
      category: { id: 3321, label: 'kredyty', value: 'kredyty' },
      deadline: 12,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [
        { year: 2020, month: 1, status: 'completed', amount: 1100 },
        { year: 2020, month: 2, status: 'completed', amount: 1100 },
        { year: 2020, month: 3, status: 'completed', amount: 1100 },
      ],
      amountExpected: 1200,
      status: 'open',
    },
    {
      id: 62391,
      name: 'Leasing samochodu',
      typePayment: 'manual',
      category: { id: 3321, label: 'kredyty', value: 'kredyty' },
      deadline: 12,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [
        { year: 2020, month: 1, status: 'completed', amount: 800 },
        { year: 2020, month: 2, status: 'completed', amount: 800 },
        { year: 2020, month: 3, status: 'completed', amount: 800 },
      ],
      amountExpected: 900,
      status: 'open',
    },
    {
      id: 32134678,
      name: 'Netflix',
      typePayment: 'manual',
      category: { id: 23331, label: 'hobby', value: 'hobby' },
      deadline: 12,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [
        { year: 2020, month: 1, status: 'completed', amount: 43 },
        { year: 2020, month: 2, status: 'completed', amount: 43 },
        { year: 2020, month: 3, status: 'completed', amount: 43 },
      ],
      amountExpected: 150,
      status: 'open',
    },
    {
      id: 2221145,
      name: 'Spotify',
      typePayment: 'manual',
      category: { id: 23331, label: 'hobby', value: 'hobby' },
      deadline: 12,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [
        { year: 2020, month: 1, status: 'completed', amount: 30 },
        { year: 2020, month: 2, status: 'completed', amount: 30 },
        { year: 2020, month: 3, status: 'completed', amount: 30 },
        { year: 2020, month: 4, status: 'completed', amount: 30 },
      ],
      amountExpected: 150,
      status: 'open',
    },
    {
      id: 45321,
      name: 'Kurs angielskiego',
      typePayment: 'auto',
      category: { id: 12333, label: 'nauka', value: 'nauka' },
      deadline: 12,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [],
      amountExpected: 150,
      status: 'open',
    },
    {
      id: 32225678,
      name: 'Eduweb',
      typePayment: 'auto',
      category: { id: 12333, label: 'nauka', value: 'nauka' },
      deadline: 15,
      year: [2020],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      history: [],
      amountExpected: 70,
      status: 'open',
    },
  ],
  categories: [
    { id: 2321, label: 'czynsz', value: 'czynsz' },
    { id: 23331, label: 'hobby', value: 'hobby' },
    { id: 3321, label: 'kredyty', value: 'kredyty' },
    { id: 1233, label: 'multimedia', value: 'multimedia' },
    { id: 12333, label: 'nauka', value: 'nauka' },
  ],
};
